import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { getLang } from 'shared/store/selectors/lang.selector';
import styles from './hub-content-banner.module.scss';

/**
 * HubContentBanner component - displays a banner indicating that the user is viewing hub content
 *
 * @returns
 */
export function HubContentBanner() {
  const lang = useSelector(getLang('KNOWLEDGE_HUB'));

  return (
    <div className={styles.banner}>
      <div className={styles.noteSection}>
        <FontAwesomeIcon icon={faCircleInfo} className={styles.icon} />
        <span>{lang.HUB_BANNER_NOTE}</span>
      </div>
      <div className={styles.messageSection}>{lang.HUB_BANNER_MESSAGE}</div>
    </div>
  );
}
